import React from 'react';
import { useI18n } from '../hooks/useI18n';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPage: React.FC = () => {
    const { t, isRTL } = useI18n();

    const sections = [
        'collection',
        'use',
        'cookies',
        'sharing',
        'security',
        'retention',
        'rights',
        'changes'
    ];

    return (
        <div
            className={`min-h-screen bg-gray-50 direction-${isRTL ? 'rtl' : 'ltr'}`}
            dir={isRTL ? 'rtl' : 'ltr'}
        >
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {/* Header */}
                <div className="flex justify-between items-center mb-8">
                    <Link
                        to="/"
                        className="inline-flex items-center text-gray-600 hover:text-blue-600 transition-colors"
                    >
                        <ArrowLeft className={`h-5 w-5 ${isRTL ? 'ml-2 rotate-180' : 'mr-2'}`} />
                        {t('common.back')}
                    </Link>
                    <LanguageSwitcher />
                </div>

                <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
                    <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
                        {t('privacyPage.title')}
                    </h1>
                    <p className="text-sm text-gray-500 mb-8">
                        {t('privacyPage.lastUpdated', {
                            date: new Date().toLocaleDateString()
                        })}
                    </p>

                    {/* Intro */}
                    <p className="text-gray-600 mb-10">
                        {t('privacyPage.intro')}
                    </p>

                    {/* Table of Contents */}
                    <nav className="mb-12">
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">
                            {t('common.contents')}
                        </h2>
                        <ul className="space-y-2 text-sm">
                            {sections.map((key) => (
                                <li key={key}>
                                    <a
                                        href={`#${key}`}
                                        className="text-blue-600 hover:underline"
                                    >
                                        {t(`privacyPage.sections.${key}.title`)}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Sections */}
                    <div className="prose max-w-none text-gray-600 space-y-12">
                        {sections.map((key) => (
                            <section key={key} id={key} className="scroll-mt-24">
                                <h2 className="text-xl mt-3 font-bold text-gray-900 mb-2">
                                    {t(`privacyPage.sections.${key}.title`)}
                                </h2>
                                <p>
                                    {t(`privacyPage.sections.${key}.content`)}
                                </p>
                            </section>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPage;
